import { deleteIndustry } from "@/api/industries";
import { DestructiveDialog } from "@/components/shared/dialogs/destructive-dialog/DestructiveDialog";
import { DestructiveDialogProps } from "@/components/shared/dialogs/destructive-dialog/DestructiveDialog.types";
import { Delete } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { useQueryClient } from "@tanstack/react-query";
import { useDialogs } from "@toolpad/core";

interface Props {
    industryId: number;
}

export const DeleteIndustryButton = ({ industryId }: Props) => {
    const dialogs = useDialogs();
    const queryClient = useQueryClient();

    const dialogProps: DestructiveDialogProps = {
        itemId: industryId,
        subject: "industry",
        mutationFn: deleteIndustry,
        onSucceeded: () => {
            queryClient.invalidateQueries({
                queryKey: ["admin-industries"],
            });
        },
    };

    const handleDelete = async () => {
        await dialogs.open(DestructiveDialog, dialogProps);
    };

    return (
        <GridActionsCellItem
            icon={
                <Tooltip title="Delete Industry">
                    <Delete />
                </Tooltip>
            }
            label="Delete"
            onClick={handleDelete}
        />
    );
};
